import { z } from "zod/v4"

export const trainingSchema = z.object({
  // biome-ignore lint/style/useNamingConvention: Allow __typename
  __typename: z.literal("Training").default("Training"),
  id: z.string(),
})

export type TTraining = z.infer<typeof trainingSchema>
